import { useQuery } from '@tanstack/vue-query';
import { fetchPendingActions } from '@/features/pending/api';

/**
 * Shared between the panel on the home page and the counter in the navigation.
 *
 * One query key, so the two never disagree: a badge saying three beside a list showing two
 * is worse than no badge, because it sends somebody looking for work that is not there.
 */
export function usePendingActions() {
  return useQuery({
    queryKey: ['pending-actions'],
    queryFn: ({ signal }) => fetchPendingActions(signal),
    // Long enough not to refetch on every navigation, short enough that a colleague's
    // request shows up without a reload.
    staleTime: 30_000,
  });
}
